import { render, staticRenderFns } from "./switchlogout.vue?vue&type=template&id=378cbc64&"
import script from "./switchlogout.vue?vue&type=script&lang=js&"
export * from "./switchlogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports